const PAGE_CONTENT = `### Frontend Stack
* React
* MaterialUI
* LogRocket
* Google Tag Manager
* Google Analytics
* LaunchDarkly

### Backend/IaC/DevOps Stack
* Github
* Github Actions
* AWS S3
* AWS CloudFront
* AWS Route53
* AWS Certificate Manager
* Terraform
* Terraform Cloud

### My Intention(s)
I've approached my life and career with a "continuous improvement" mindset so I've picked up several skills never siloing or limiting myself to one area of technology. Because of this my experience is quite broad and varied so I've come to the conclusion that I need a central archive that would allow me to:
1) Keep a history of all of the projects I've done, things that I've learned and easily direct others who are curious to it
2) Explain my mindset and reasoning for why I do things or why I architected/engineered things the way I did
3) Exhaustively show who I am to any hiring managers

Throughout my career I'd ran into several occassions where I'd felt like I was not easily able to "show off" my experience or projects. With this site, my objective is simply to pour my heart and soul out to anyone who would like to know about me. If someone curious can simply view my portfolio and understand me better then my job here is finished.

To some, I imagine this site can basically be described as a "Brag doc" with extra steps (haha).

### Why React?
I've written this website in React/JSX in the hopes of showcasing some of my software development skills. I understand that developing a site like this from scratch instead of using a template or site builder is not the most optimal method from a speed/effort perspective. However, my intention with this site is to demonstrate all of my skills and thus creating it from from zero(ish) would be a better indicator of my knowledge and ability. I hope you (whoever you may be) agree as well.

### "Just use Github?"
While I think Github is a great tool to "let the code speak for itself" it lacks in several ways that would not work for me. One of those is the way in which I'd like to present certain things or ideas. For example: I'd like to be able to animate or code in features on the portfolio site that wouldn't work with just a pure Github approach. Another reason is some of the skills can be demonstrated in action better than they can be expressed in code. Lastly it's a bad taste for anyone viewing my Github as perusing through several repos with no direction is not very appealing to most nor is it time-effective.`;

const CONTENT = {
    PAGE_CONTENT,
}

export default CONTENT;